import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.production";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { EstatusVehiculoResponseEdicion } from "../pojos/estatusVehiculoResponseEdicion";

@Injectable({
    providedIn: 'root'
})
export class EditarSolicitudEstatalFisica {
    private endPoint: string = `${environment.HOST_EDICION}/editar-solicitud-fisica`;

    constructor(private http: HttpClient)
    {

    }

    editarEstatalFisica(data:any): Observable<EstatusVehiculoResponseEdicion> {
        const params = new HttpParams()
        .set('data', data)
        return this.http.get<EstatusVehiculoResponseEdicion>(this.endPoint, { params });
    }
}